import request from '@/utils/request'
import {
    baseUrl
} from './baseUrl.js'

/**
 * 管理后台登录
 */
export function akLogin(data) {
    return request({
        url: baseUrl + '/backer/backerLogin/loginPassword',
        method: 'post',
        data
    })
}

/**
 * 注册发送验证码
 */
export function akSendRegisterCode(data) {
    return request({
        url: baseUrl + '/user/login/registerSendVerifyCode',
        method: 'post',
        data
    })
}

/**
 * 注册
 */
export function akRegister(data) {
    return request({
        url: baseUrl + '/user/login/registerPhoneNumber',
        method: 'post',
        data
    })
}


/**
 * 找回密码发送验证码
 */
export function akSendPasswordCode(data) {
    return request({
        url: baseUrl + '/user/login/findPasswordSendVerifyCode',
        method: 'post',
        data
    })
}

/**
 * 找回密码
 */
export function akFindPassword(data) {
    return request({
        url: baseUrl + '/user/login/findPassword',
        method: 'post',
        data
    })
}


